export const NodalOfficerMenu = [
  {
    title: "Escalated Complaints",
    iconStyle: imagepaths.complaintsIcon,
    iconActive: imagepaths.complaintsIconActive,
    to: "/app/escalatedcomplaints",
    id: "escalatedcomplaints",
  },
]